// extracted by mini-css-extract-plugin
module.exports = {"container":"TlkEAkozGKdW7wJjfrpxg"};